<template>
    <div class="purchase-page">
        <el-dialog title="资源购买确认信息" :visible.sync="isVisibleResPay" width="700px" :before-close="handleClose">
            <el-descriptions title="资源信息" direction="vertical" :column="3" border>
                <el-descriptions-item label="资源名称">{{ confirmData.resourceName }}</el-descriptions-item>
                <el-descriptions-item label="CPU核心数">{{ confirmData.cpuCore }}</el-descriptions-item>
                
                <el-descriptions-item label="内存容量">{{ confirmData.memoryCapacity }}GB</el-descriptions-item>
                <el-descriptions-item label="硬盘容量">{{ confirmData.hardDisk }}GB</el-descriptions-item>
                <el-descriptions-item label="型号">{{ confirmData.model }}</el-descriptions-item>
                <el-descriptions-item label="卡数">{{ confirmData.cardsNum }}</el-descriptions-item>
                <el-descriptions-item label="组网">{{ confirmData.networking }}</el-descriptions-item>
                <!-- <el-descriptions-item label="台数">5</el-descriptions-item> -->
                <el-descriptions-item label="可租台数">
                    <!-- {{ confirmData.rentableNum }} -->
                    <el-input v-model="confirmData.rentableNum" class="handle-input" placeholder="请输入可租台数"></el-input>
                </el-descriptions-item>
                <el-descriptions-item label="地点">{{ confirmData.address }}</el-descriptions-item>
                <el-descriptions-item label="资源状态" >
                    <span v-if="confirmData.rentOn == 1">随时可租</span>
                    <span v-else>指定日期可租</span>
                </el-descriptions-item>
                <el-descriptions-item label="可租日期" >{{ confirmData.rentDate || '-'}}</el-descriptions-item>
                <el-descriptions-item label="月租金额" v-if="confirmData.monthRent != null">{{ confirmData.monthRent }}元/月</el-descriptions-item>
                <el-descriptions-item label="年租金额" v-else-if="confirmData.yearRent != null">{{ confirmData.yearRent }}元/年</el-descriptions-item>
                
                <!-- <el-descriptions-item label="可接受的付款方式">{{ confirmData.payType }}</el-descriptions-item> -->
                <el-descriptions-item label="资源描述" :span="12">{{ confirmData.resourceDesc }}</el-descriptions-item>
                <el-descriptions-item label="备注" :span="12">{{ confirmData.remark }}</el-descriptions-item>
            </el-descriptions>
            <!-- <el-descriptions title="用户信息" direction="vertical" :column="2" border class="mt20">
                
            </el-descriptions> -->
            <el-descriptions title="订单信息" direction="vertical" :column="2" border class="mt20">
                <el-descriptions-item label="租用台数">
                    <el-input v-model="order.rentableNum" placeholder="请输入租用台数"></el-input>
                </el-descriptions-item>
                <el-descriptions-item label="租用类型">
                    <!-- // 如果是有月租和年租 租用类型可选择月租 -->
                    <!-- // 如果是只有年租 租用类型仅选择年租 -->
                    <el-radio-group v-model="order.rentType" v-if="confirmData.monthRent != null ">
                        <el-radio label="1">按月租用</el-radio>
                        <el-radio label="2" disabled>按年租用</el-radio>
                    </el-radio-group>
                    <el-radio-group v-model="order.rentType" v-else>
                        <el-radio label="1" disabled>按月租用</el-radio>
                        <el-radio label="2">按年租用</el-radio>
                    </el-radio-group>
                </el-descriptions-item>
                <el-descriptions-item label="租用日期">
                    <el-date-picker
                        v-model="order.rentDate"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择租用日期"
                    >
                    </el-date-picker>
                </el-descriptions-item>
                <el-descriptions-item label='租用时长'>
                    <el-input v-model="order.rentTime" placeholder="请输入租用时长">
                        <template #append>
                            <span v-if="order.rentType == 1">月</span>
                            <span v-else>年</span>
                        </template>
                    </el-input>
                </el-descriptions-item>
                <el-descriptions-item label="联系人">
                    <el-input v-model="confirmData.resourceLinkName" placeholder="请输入联系人"></el-input>
                </el-descriptions-item>
                <el-descriptions-item label="联系方式">
                    <el-input v-model="confirmData.resourceLinkPhone" placeholder="请输入用户名称"></el-input>
                </el-descriptions-item>
            </el-descriptions>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleClose">取 消</el-button>
                <el-button type="primary" @click="confirmBuy">确 认</el-button>
            </div>
        </el-dialog>
    </div>

</template>

<script>
import {
    resourceBuyConfirm,
    resourceBuy
} from '@/api/index'
export default {
    props:['isVisibleResPay','buyData'],
    watch:{
        isVisibleResPay(val){
            if(val){
                this.getConfirmMessage();
            }
        }
    },
    data(){
        return{
            confirmData:{},
            order:{
                rentableNum:1,
                rentType:'1',
                rentDate:'',
                rentTime:'1',//不论月租or年租 默认是1月或1年
            },
        }
    },
    mounted(){

    },
    methods:{
        async getConfirmMessage(){
            let cloud_login_user_role = sessionStorage.getItem('cloud_login_user_role');//用户权限 /1个人需求 2公司需求 3资源 4渠道
            const data = await resourceBuyConfirm(cloud_login_user_role,this.buyData.flagId);
            if(data.success){
                this.confirmData = data.data;
                // 如果是有月租和年租 租用类型选择月租
                // 如果是只有年租 租用类型仅选择年租
                if(this.confirmData.monthRent != null ){
                    this.order.rentType = '1';
                }else if(this.confirmData.yearRent != null){
                    this.order.rentType = '2';
                }
            }
        },
        confirmBuy(){
            let cloud_login_user_role = sessionStorage.getItem('cloud_login_user_role');//用户权限 /1个人需求 2公司需求 3资源 4渠道
            //判断 order.rentableNum 不能大于 confirmData.rentableNum
            if(this.order.rentableNum > this.confirmData.rentableNum){
                this.$message.error('租用台数不能大于可租用台数');
                return;
            }
            // order.rentableNum 不能小于1且为正整数 不能带小数点
            if(this.order.rentableNum < 1 || this.order.rentableNum % 1 != 0){
                this.$message.error('租用台数不能小于1且为正整数');
                return;
            }
            if(!this.order.rentDate){
                this.$message.error('请选择租用日期');
                return;
            }
            // rentOn = 2 时 起租日期 不能大于 可租日期
            if(this.order.rentType == 2){
                if(this.order.rentDate > this.confirmData.endDate){
                    this.$message.error('租用日期不能大于可租日期');
                    return;
                }
            }
            //正则验证手机号 
            if(!/^1[3456789]\d{9}$/.test(this.confirmData.resourceLinkPhone)){
                this.$message.error('手机号格式错误');
                return;
            }
            let data = {
                resourceBatch:this.confirmData.batchId,//资源批次id
                resourceNum:this.order.rentableNum,//购买资源台数
                unitPrice:this.confirmData.monthRent != null?this.confirmData.monthRent:this.confirmData.yearRent,// 资源单价
                timeLength:this.order.rentTime,//资源时长
                userType:cloud_login_user_role,//1 个人需求用户  2企业需求用户
                linkName:this.confirmData.resourceLinkName,//联系人
                linkPhone:this.confirmData.resourceLinkPhone,//联系人电话
                resourceName:this.confirmData.resourceName,//资源名称
                resourceDesc:this.confirmData.resourceDesc,//资源描述
                cpuCore:this.confirmData.cpuCore,//cpu核数
                memoryCapacity:this.confirmData.memoryCapacity,//内存容量
                hardDisk:this.confirmData.hardDisk,//硬盘容量
                address:this.confirmData.address,//地点
                model:this.confirmData.model,//型号
                cardsNum:this.confirmData.cardsNum,//卡数
                networking:this.confirmData.networking,//组网
                rentDate:this.order.rentDate,//计划租用日期
                rentType:this.order.rentType,//租用类型 1 按月租用 2 按年租用
            }
            resourceBuy(data).then(res=>{
                if (res.data) {
                    // this.$message.success('购买申请已提交');
                    // 关闭弹窗
                    this.$emit('update:isVisibleResPay',false);
                    // 购买说明 提示信息
                    this.$alert(
                        `<div style="font-size:16px;">购买申请已提交</div>
                        <div style="font-size:16px;">等待资源方联系确认</div>`, '提示', {
                        showClose:false,
                        confirmButtonText: '确定',
                        dangerouslyUseHTMLString: true,
                    });
                }
            })
        },
        handleClose(){
            this.$emit('update:isVisibleResPay',false);
        }
    }
    
}
</script>


<style scoped>

.purchase-page{
    cursor:default;
}
.el-date-picker{
    width:100%;
}
/* .handle-input{
    width:220px;
} */
.el-date-editor.el-input,.el-input__inner{
    width:100%;
    
}
</style>